import { render, staticRenderFns } from "./noDataVillage.vue?vue&type=template&id=25cd2971&scoped=true&"
import script from "./noDataVillage.vue?vue&type=script&lang=js&"
export * from "./noDataVillage.vue?vue&type=script&lang=js&"
import style0 from "./noDataVillage.vue?vue&type=style&index=0&id=25cd2971&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cd2971",
  null
  
)

export default component.exports